module.exports = __webpack_public_path__ + "img/cooperation3.a8f4cf78.png";